import { Suspense, useEffect } from 'react';
import { useRecoilState } from 'recoil';

import { Routes, Route, Link } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { Container, List, ListItemText, ListItemButton } from '@mui/material';

import { userState } from '@/atoms';
import { getUser } from '@/repositories/HttpRepository';

import { lightTheme } from '@/themes';
import Header from '@/components/Header';
import AssignmentRoot from './Assignment';

import SqlExecution from './SqlExecution';
import ZipCodeScreen from './Zipcode';
import PricingShipMonkSimulation from './ShipMonk';
import ObjectViewerContainer from './ObjectViewer';
import DwellTimeStats from './DwellTimeStats';

function RootContainer() {
  const [user, setUser] = useRecoilState(userState);
  useEffect(() => {
    getUser()
      .then((resp) => {
        if (resp.ok) {
          setUser(resp.data);
        } else {
          window.location = `${import.meta.env.REACT_APP_OAUTH_URL}/login`;
        }
      })
      .catch(() => {
        window.location = `${import.meta.env.REACT_APP_OAUTH_URL}/login`;
      });
  }, []);

  if (!user) return <div>Loading...</div>;

  return (
    <ThemeProvider theme={lightTheme}>
      <Header user={user} />
      <Routes>
        <Route path="/sql/create" element={<SqlExecution />} />
        <Route
          path="/zipcode"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <ZipCodeScreen />
            </Suspense>
          }
        />
        <Route
          path="/dwelltime"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <DwellTimeStats />
            </Suspense>
          }
        />
        <Route
          path="/assignments/*"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <AssignmentRoot />
            </Suspense>
          }
        />
        <Route
          path="/shipmonk/*"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <PricingShipMonkSimulation />
            </Suspense>
          }
        />
        <Route path="/object-viewer/*" element={<ObjectViewerContainer />} />
        <Route
          path="/"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <Container sx={{ p: 3 }}>
                <h3>Jitsu Internal Tools</h3>
                <List component="nav">
                  <ListItemButton component={Link} to="/assignments">
                    <ListItemText primary="Assignments" secondary="Update assignments Time" />
                  </ListItemButton>
                  <ListItemButton component={Link} to="/zipcode">
                    <ListItemText primary="Zipcode" secondary="Zipcode inquiry by pickup location" />
                  </ListItemButton>
                </List>
              </Container>
            </Suspense>
          }
        />
      </Routes>
    </ThemeProvider>
  );
}

export default RootContainer;
